import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const savingPositiveKeywords = ReducerUtils.createReducer(false,{
  [Actions.SAVING_POSITIVE_KEYWORDS] : (state,action)=>action.status,
})

export default savingPositiveKeywords